<div class="grid" *ngIf="controller">
	<div class="col-12">
		<div class="flex justify-content-start align-items-center">
			<p-button icon="pi cm-pencil" label="{{ 'EDIT_ROW' | translate }}" (click)="modificaRiga()" [text]="true" severity="secondary" styleClass="font-bold">
			</p-button>
			<p-button icon="pi cm-trash" label="{{ 'DELETE_ROW' | translate }}" (click)="eliminaRiga()" [text]="true" severity="danger" styleClass="font-bold">
			</p-button>
		</div>
	</div>
</div>

<div *ngIf="row.ContentType ==='text'" class="grid">
	<div class="col-12 flex justify-content-center text-center">
		<div [innerHTML]="row.Content"></div>
	</div>
</div>
<div *ngIf="row.ContentType ==='video'" class="grid">
	<div class="col-12 flex justify-content-center text-center">
		<youtube-player class="overflow-auto" [playerVars]="{'rel': 0, 'modestbranding': 1, 'iv_load_policy': 3}" videoId="{{row.Content}}" [startSeconds]="row.SecondStart" [endSeconds]="row.SecondEnd"></youtube-player>
	</div>
</div>
<div *ngIf="row.ContentType ==='image'" class="grid justify-content-center align-items-center">
	<div class="col-12">
		<div class="imageHelper">
			<a [href]="getImageContent(row.Content)" target="_blank" *ngIf="!mobile">
				<img [src]="getImageContent(row.Content)">
			</a>
			<img [src]="getImageContent(row.Content)" *ngIf="mobile">
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle" (click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle" (click)="confDialog.reject()">
			</button>
			</div>
	</ng-template>
</p-confirmDialog>